import { TConfig, TConfigInput, TGetAddOns } from '@@/auto/interfaces';
import { excludeFalse } from '@@/auto/utils/excludeFalse';

function ToyotaAZConfig(): DeepPartial<TConfigInput> {
  return {
    auto: (auto: TConfig['auto']) => ({
      ...auto,
      addOns: {
        ...auto.addOns,
        getAddOns: ({ userAction }: Parameters<TGetAddOns>[0]) =>
          excludeFalse([
            'towing_road_services',
            'temporary_ride',
            'side_hustle',
            'oem_parts',
            'new_car_replacement',
            'glass',
            userAction === 'editing-addons' && 'pet_passenger',
          ] as const),
      },
    }),
  };
}
export default ToyotaAZConfig;
